var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D86464",
    stroke: "transparent",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM11.6503 13.648H12.1622C12.3062 13.648 12.4503 13.52 12.4663 13.392L13.0903 8.896V7.104C13.0903 6.944 12.9462 6.8 12.7863 6.8H11.0262C10.8663 6.8 10.7222 6.944 10.7222 7.104V8.928L11.3462 13.392C11.3622 13.52 11.5063 13.648 11.6503 13.648ZM10.5942 16.848C10.5942 17.568 11.1863 18.16 11.8903 18.16C12.6263 18.16 13.2183 17.568 13.2183 16.848C13.2183 16.128 12.6263 15.52 11.8903 15.52C11.1863 15.52 10.5942 16.128 10.5942 16.848Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.906bb838b0f7184519a14486d5ba80b4.svg";
export { ForwardRef as ReactComponent };